export default __webpack_public_path__ + "static/media/pileofgoldsmaller.dcec62db.png";